<template>
  <div>
    <!-- Header -->
    <div class="py-3 mb-3 border-bottom">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-3 d-flex">
                    <h5 class="m-0 p-0 align-self-center">
                        <i class="fas fa-chart-bar mr-1"></i> Ranking
                    </h5>
                </div>
                <!--

                    <div class="col-12 col-sm-9 text-left d-flex justify-content-end">
                        <div class="d-flex gap-2">

                            <div class="">
                                <multiselect
                                    v-model="mode"
                                    :options="modes"
                                    :loading="loadingMode"
                                    track-by="id"
                                    label="name"
                                    @select="selectMode"
                                    @remove="removeMode"
                                    placeholder="Filtrar por Modo ..."
                                    tag-placeholder="Filtrar Modo"
                                    selectLabel="Selecionar"
                                    deselectLabel="Desmarcar"
                                    selectedLabel="Selecionado">

                                    <span slot="noResult">
                                        Ops! Nenhum resultado encontrado na pesquisa :(
                                    </span>

                                    <span slot="noOptions">
                                        Não há turmas disponíveis para exibir :(
                                    </span>
                                </multiselect>
                            </div>
                            <div class="">
                                <multiselect
                                    v-model="group"
                                    :options="groups"
                                    :loading="loadingGroup"
                                    track-by="id"
                                    label="name"
                                    @select="selectGroup"
                                    @remove="removeGroup"
                                    placeholder="Filtrar por Turma ..."
                                    tag-placeholder="Filtrar Turma"
                                    selectLabel="Selecionar"
                                    deselectLabel="Desmarcar"
                                    selectedLabel="Selecionado">

                                    <span slot="noResult">
                                        Ops! Nenhum resultado encontrado na pesquisa :(
                                    </span>

                                    <span slot="noOptions">
                                        Não há turmas disponíveis para exibir :(
                                    </span>
                                </multiselect>
                            </div>
                            <div class="d-flex">

                                <change-date :start-date="from" :end-date="to" locale="pt-BR" @changeDate="changeDate" class="ml-sm-auto flex-grow-1 mr-auto mr-sm-3 mt-3 mt-sm-0"></change-date>
                            </div>
                        </div>
                    </div>
                -->
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-4 mb-3">
                <multiselect
                    v-model="mode"
                    :options="modes"
                    :loading="loadingMode"
                    track-by="id"
                    label="name"
                    @select="selectMode"
                    @remove="removeMode"
                    placeholder="Filtrar por Modo ..."
                    tag-placeholder="Filtrar Modo"
                    selectLabel="Selecionar"
                    deselectLabel="Desmarcar"
                    selectedLabel="Selecionado">

                    <span slot="noResult">
                        Ops! Nenhum resultado encontrado na pesquisa :(
                    </span>

                    <span slot="noOptions">
                        Não há turmas disponíveis para exibir :(
                    </span>
                </multiselect>
            </div>
            <div class="col-12 col-sm-4 mb-3">
                <multiselect
                    v-model="group"
                    :options="groups"
                    :loading="loadingGroup"
                    track-by="id"
                    label="name"
                    @select="selectGroup"
                    @remove="removeGroup"
                    placeholder="Filtrar por Turma ..."
                    tag-placeholder="Filtrar Turma"
                    selectLabel="Selecionar"
                    deselectLabel="Desmarcar"
                    selectedLabel="Selecionado">

                    <span slot="noResult">
                        Ops! Nenhum resultado encontrado na pesquisa :(
                    </span>

                    <span slot="noOptions">
                        Não há turmas disponíveis para exibir :(
                    </span>
                </multiselect>
            </div>
            <div class="d-flex col-12 col-sm-4 mb-3">

                <change-date :start-date="from" :end-date="to" locale="pt-BR" @changeDate="changeDate" class="ml-sm-auto flex-grow-1 mr-auto mr-sm-3 mt-3 mt-sm-0"></change-date>
            </div>
        </div>
    </div>
    <div class="container">

        <b-overlay :show="loading" class="row">
            <div class="col-sm-4 mb-3" v-for="(student,index) in podium" :key="index" >
                <div class="card " v-if="student.average_note">
                    <div class="card-header text-white" :style="'background-color:'+ podiumColor[index]+' !important ; '">{{ index +1 }}° Lugar</div>
                    <div class="card-body text-center d-flex flex-column align-items-center " >
                        <p class="text-capitalize fw-bolder">
                            {{ student.name }}
                        </p>
                        <div class="mt-3 d-flex gap-2 text-center">
                            <div>
                                <div class="text-black-50">
                                    Maior
                                </div>
                                <div class="px-2 py-1 fw-normal">

                                    {{ student.max_note }}
                                </div>
                            </div>
                            <div class="navbar-item-separator"></div>
                            <div>
                                <div class="text-black-50">
                                    Média
                                </div>
                                <div class="px-2 py-1 fw-normal">

                                    {{ student.average_note.toFixed(2) }}
                                </div>
                            </div>
                            <div class="navbar-item-separator"></div>
                            <div>
                                <div class="text-black-50">
                                    Menor
                                </div>
                                <div class="px-2 py-1 fw-normal">

                                    {{ student.min_note }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-overlay>

        <b-overlay :show="loading">
            <div class="mb-3">
                <table-ranking :table="EssaysData" :podium="podium" :per-page="perPage" :page="currentPage"></table-ranking>
            </div>
            <div class="d-flex justify-content-between">

                <b-pagination
                    v-model="currentPage"
                    :total-rows="total"
                    :per-page="perPage"
                    @change="changePage"
                />
                <div>{{ total }} resultados</div>
            </div>
        </b-overlay>
    </div>
</div>

</template>

<script>
import ChangeDate from "./ChangeDate.vue";
import TableRanking from "./Table.vue"
export default {
    components: {
        ChangeDate,
        TableRanking
    },
    props: ['from', 'to', 'groups', 'modes'],
    data() {
        return {
            currentPage: 1,
            total: 0,
            perPage: 10,
            loading: false,
            loadingGroup: false,
            loadingMode: false,
            EssaysData: [],
            podium: [],
            podiumColor: [
                'darkgoldenrod',
                'darkgray',
                'saddlebrown'
            ],
            filter: {
                start_date: this.from,
                end_date: this.to,
                group_id: null,
                mode_id: null,
            },
            group: null,
            mode: null
        }
    },
    created() {

        // Load
        this.load()

    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/teacher/reports-students/ranking/data', {
                params: {
                    from: this.$moment(this.filter.start_date).format('YYYY-MM-DD'),
                    to: this.$moment(this.filter.end_date).format('YYYY-MM-DD'),
                    group_id: this.filter.group_id,
                    mode_id: this.filter.mode_id,

                    per_page: this.perPage,
                    page: this.currentPage,

                }
            })
                .then(async (result) => {
                    const response = result.data.data;
                    this.EssaysData = response.students.data;
                    this.total = response.students.total;
                    this.podium = response.podium;
                })
                .finally(() => this.loading = false)
        },

        async selectGroup(value) {
            this.filter.group_id = await value.id;

            // Load
            await this.load()
        },

        async removeGroup() {
            this.filter.group_id = await null;

            // Load
            await this.load()
        },
        async selectMode(value) {
            this.filter.mode_id = await value.id;

            // Load
            await this.load()
        },
        async removeMode() {
            this.filter.mode_id = await null;

            // Load
            await this.load()
        },

        async changeDate(dateFilters) {
            this.filter.start_date = await dateFilters.startDate;
            this.filter.end_date = await dateFilters.endDate;

            // Load
            await this.load()
        },
        async changePage(page){
            this.currentPage = await page;

            await this.load()
        }


    }
}
</script>

<style>

</style>
